<template>
  <svg
    :class="['w-10 h-10 cursor-pointer', status ? '' : 'close']"
    width="52"
    height="51"
    viewBox="0 0 52 51"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter x="-24.8%" y="-22.2%" width="149.6%" height="149.6%" filterUnits="objectBoundingBox">
        <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.384313725   0 0 0 0 0.211764706   0 0 0 0 1  0 0 0 0.282151442 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
      <circle id="a" cx="19.157" cy="19.157" r="19.157" />
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(6.61 5)">
        <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#a" />
        <circle
          stroke="#BAADF5"
          stroke-width="1.485"
          stroke-linejoin="square"
          fill="#FFFFFF"
          fill-rule="evenodd"
          cx="19.157"
          cy="19.157"
          r="18.414"
        />
      </g>
      <path
        stroke="#BAADF5"
        stroke-width="1.386"
        stroke-linecap="round"
        d="M24.76 18.53l-5.61 5.61 5.61 5.61M32.35 18.53l-5.61 5.61 5.61 5.61"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TipIcon extends Vue {
  @Prop({ type: Boolean }) status: boolean;
}
</script>

<style scoped>
svg:hover circle,
svg:hover path {
  stroke: rgb(108, 72, 233);
}
svg.close {
  transform: rotate(180deg);
}
</style>
